import { apiService } from '../core'

export const getToken = async () => {
  const { data } = await apiService.get(`api/Zendesk/Token`)
  return data
}
